import { useState } from "react";
import { X } from "lucide-react";
import { api, type Site } from "../lib/api";
import { useAppDialog } from "./AppDialog";

export default function CancelBuildButton({
  site,
  onCancelled,
  className = "btn",
}: {
  site: Pick<Site, "id" | "pendingBuildId">;
  onCancelled?: () => void;
  className?: string;
}) {
  const dialog = useAppDialog();
  const [cancelling, setCancelling] = useState(false);
  if (!site.pendingBuildId) return null;

  async function cancel() {
    if (!site.pendingBuildId) return;
    const confirmed = await dialog.confirm({
      title: "Stop this build?",
      body: "You can start a new one whenever you're ready.",
      confirmLabel: "Stop build",
      cancelLabel: "Keep building",
      tone: "danger",
    });
    if (!confirmed) return;
    setCancelling(true);
    try {
      await api.cancelBuild(site.id, site.pendingBuildId);
      onCancelled?.();
    } catch (reason: any) {
      await dialog.notify({
        title: "The build could not be cancelled",
        body: reason?.payload?.error || reason?.message || "It may have already finished. Refresh to see where it landed.",
        tone: "danger",
      });
    } finally {
      setCancelling(false);
    }
  }

  return (
    <button type="button" className={`${className} cancel-build-button`} onClick={() => void cancel()} disabled={cancelling}>
      <X size={14} />
      {cancelling ? "Cancelling…" : "Cancel build"}
    </button>
  );
}
